<template>
  <div class="card is-height-70p">
    <gmap-map
      :center="centerDefault"
      :zoom="zoomDefault"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      @tilesloaded="levelZoom"
      class="googleMap"
      id="mapGroupe"
      ref="mapCartoGeneralGroupe"
      @zoom_changed="getZoom = $event">

      <!-- Marker point de vente -->
      <gmap-marker
        v-for="(markerPdv, i) in filtrePdvs"
        :key="'pdv'+i"
        :position="markerPdv.adresse.coordonnees"
        :icon="markerPdv.icon"
        @click="accessRecom(markerPdv.previewLink)">
      </gmap-marker>

      <gmap-cluster :minimumClusterSize="7">
        <!-- Marker panneau -->
        <gmap-marker
          v-for="(markerPan, i) in filtrePanneaux"
          :key="'pan'+i"
          :position="markerPan.adresse.coordonnees"
          :icon="getIconPanneau(markerPan)">
        </gmap-marker>
      </gmap-cluster>
      
    </gmap-map>
  </div>
</template>

<script>
import { CENTER_DEFAULT, ZOOM_DEFAULT,
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/gestionIconMarker/iconColorGetter';

export default {
  props: {
    pointDeVentes: Array,
    panneaux: Array
  },
  data() {
    return {
      isLoadOnce: false,
      centerDefault: CENTER_DEFAULT,
      zoomDefault: ZOOM_DEFAULT,
      getZoom: 0,
      isLoading: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  watch: {
    async filtrePdvs(val) {
      if (!val.length) return;
      await this.levelZoom();
    },
    async filtrePanneaux(val) {
      if (!val.length) return;
      await this.levelZoom();
    },
  },
  computed: {
    filtrePdvs() {
      if (!this.pointDeVentes.length) return [];
      if (this.$route.name === 'ListePointDeVente') {
        return this.pointDeVentes.filter(pdv => pdv.idEnseigne === this.$route.params.id);
      }
      return this.pointDeVentes;
    },
    filtrePanneaux() {
      if (!this.panneaux.length) return [];
      if (this.$route.name === 'ListePointDeVente') {
        return this.panneaux.filter(pdv => pdv.idEnseigne === this.$route.params.id);
      }
      return this.panneaux;
    }
  },
  methods: {
    getIconPanneau(panneau) {
      if (panneau.ancienPanneau == "OUI") {
        return iconColorGetter('#4d4d4d', TAILLE_ICON_GRAND, panneau.azimut, true);
      } else return iconColorGetter(panneau.couleur, TAILLE_ICON_GRAND, panneau.azimut, true);
    },
    async levelZoom() {
      const bounds = new google.maps.LatLngBounds();
      this.filtrePdvs.forEach(el => {
        bounds.extend(el.adresse.coordonnees);
      });
      this.filtrePanneaux.forEach(el => {
        bounds.extend(el.adresse.coordonnees);
      });
      this.$refs.mapCartoGeneralGroupe.fitBounds(bounds);
      const map = await this.$refs.mapCartoGeneralGroupe.$mapPromise;
      map.setZoom(this.getZoom - 1);
    },
    accessRecom(lien){
      window.open(lien);
    },
  },
  async mounted() {
    const map = await this.$refs.mapCartoGeneralGroupe.$mapPromise;
    const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
      name: MAP_TYPE_NAME,
    });
    map.mapTypes.set('styled_map', styleMap);
  },
};
</script>
